import React from "react";

const Number = ({ number }) => {
  return (
    <div className="bg-[#F4F8EC]  text-[#6A983C] p-2 rounded-full font-extrabold ">
      {number}
    </div>
  );
};

export default Number;
